var vueRangeInput = require('./vue-range-input')

module.exports = vueRangeInput



// WEBPACK FOOTER //
// ./src/index.js